export default "__VITE_ASSET__BccknQF8__"